// extracted by mini-css-extract-plugin
export default {"chatRequestDisclaimer":"tWlWM","chatRequestDisclaimerName":"OQlVL","mobile":"F7Yvk","smallMobile":"MDC6u","tablet":"fWXnT"};